import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, watch, ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { elementLocales } from './i18n'
import InstallPrompt from '@/components/InstallPrompt.vue'


export default {
  __name: 'App',
  setup(__props) {

const { locale } = useI18n()
const elementLocale = computed(() => elementLocales[locale.value] || elementLocales.uz)

const themes = {
  sand: {
    name: 'Sand',
    bgBase: 'linear-gradient(135deg, #d4c0ae 0%, #c9b5a3 30%, #bfab99 60%, #d0bfaf 100%)',
    blob1: 'radial-gradient(circle, rgba(212,133,74,.25) 0%, transparent 70%)',
    blob2: 'radial-gradient(circle, rgba(61,139,112,.2) 0%, transparent 70%)',
    blob3: 'radial-gradient(circle, rgba(255,255,255,.15) 0%, transparent 70%)',
    strip: 'linear-gradient(180deg, #1c1c2b, #2a2a3a 55%, transparent)',
    panel: 'rgba(238,232,224,.72)', card: 'rgba(255,255,255,.52)', card2: 'rgba(255,255,255,.38)',
    dark: '#1c1c2b', dark2: '#262636',
    accent: '#3d8b70', accent2: '#5aab8a', accentBg: 'rgba(61,139,112,.06)',
    orange: '#d4854a', orange2: '#e09a60', orangeBg: 'rgba(212,133,74,.06)',
    t1: '#1c1c2b', t2: '#6b6b80', t3: '#a0a0b2', t4: '#c5c5d0',
    border: 'rgba(255,255,255,.5)', border2: 'rgba(0,0,0,.05)',
    sh: '0 2px 8px rgba(0,0,0,.04), 0 8px 32px rgba(0,0,0,.04)',
    sh2: '0 4px 16px rgba(0,0,0,.06), 0 16px 48px rgba(0,0,0,.06)',
    inputBg: 'rgba(255,255,255,.45)', hoverBg: 'rgba(255,255,255,.2)',
    tableHover: 'rgba(212,133,74,.03)', loadingBg: 'rgba(238,232,224,.6)',
    glassInset: 'inset 0 1px 0 rgba(255,255,255,.5)',
    preview: ['#c9b8a8', '#d4854a', '#3d8b70'],
  },
  lavender: {
    name: 'Lavender',
    bgBase: 'linear-gradient(135deg, #c4b5d8 0%, #b8c4e8 25%, #d4bce8 50%, #a8c0e8 75%, #c8b0e0 100%)',
    blob1: 'radial-gradient(circle, rgba(167,139,250,.4) 0%, transparent 70%)',
    blob2: 'radial-gradient(circle, rgba(129,182,255,.35) 0%, transparent 70%)',
    blob3: 'radial-gradient(circle, rgba(232,200,255,.3) 0%, transparent 70%)',
    strip: 'linear-gradient(180deg, #2d2844, #3a3560 55%, transparent)',
    panel: 'rgba(235,230,248,.75)', card: 'rgba(255,255,255,.55)', card2: 'rgba(255,255,255,.38)',
    dark: '#2d2844', dark2: '#3a3560',
    accent: '#7c5cbf', accent2: '#9b7ed8', accentBg: 'rgba(124,92,191,.07)',
    orange: '#e07850', orange2: '#e89470', orangeBg: 'rgba(224,120,80,.07)',
    t1: '#2d2844', t2: '#6b6580', t3: '#9994aa', t4: '#c0bcd0',
    border: 'rgba(255,255,255,.55)', border2: 'rgba(0,0,0,.04)',
    sh: '0 2px 8px rgba(45,40,68,.05), 0 8px 32px rgba(45,40,68,.04)',
    sh2: '0 4px 16px rgba(45,40,68,.08), 0 16px 48px rgba(45,40,68,.06)',
    inputBg: 'rgba(255,255,255,.5)', hoverBg: 'rgba(255,255,255,.25)',
    tableHover: 'rgba(124,92,191,.03)', loadingBg: 'rgba(235,230,248,.65)',
    glassInset: 'inset 0 1px 0 rgba(255,255,255,.55)',
    preview: ['#c4b5d8', '#7c5cbf', '#81b6ff'],
  },
  sakura: {
    name: 'Sakura',
    bgBase: 'linear-gradient(135deg, #f0d0e8 0%, #e8c0e0 25%, #ddb8e8 50%, #e8c8f0 75%, #f0d8ec 100%)',
    blob1: 'radial-gradient(circle, rgba(236,130,200,.35) 0%, transparent 70%)',
    blob2: 'radial-gradient(circle, rgba(180,130,250,.3) 0%, transparent 70%)',
    blob3: 'radial-gradient(circle, rgba(255,200,230,.35) 0%, transparent 70%)',
    strip: 'linear-gradient(180deg, #3a2040, #4a2855 55%, transparent)',
    panel: 'rgba(248,235,245,.78)', card: 'rgba(255,255,255,.58)', card2: 'rgba(255,255,255,.4)',
    dark: '#3a2040', dark2: '#4a2855',
    accent: '#d946a8', accent2: '#e870c0', accentBg: 'rgba(217,70,168,.07)',
    orange: '#a855f7', orange2: '#c084fc', orangeBg: 'rgba(168,85,247,.07)',
    t1: '#3a2040', t2: '#7a607a', t3: '#a898a8', t4: '#c8bcc8',
    border: 'rgba(255,255,255,.55)', border2: 'rgba(0,0,0,.04)',
    sh: '0 2px 8px rgba(58,32,64,.05), 0 8px 32px rgba(58,32,64,.04)',
    sh2: '0 4px 16px rgba(58,32,64,.08), 0 16px 48px rgba(58,32,64,.06)',
    inputBg: 'rgba(255,255,255,.5)', hoverBg: 'rgba(255,255,255,.25)',
    tableHover: 'rgba(217,70,168,.03)', loadingBg: 'rgba(248,235,245,.65)',
    glassInset: 'inset 0 1px 0 rgba(255,255,255,.55)',
    preview: ['#f0d0e8', '#d946a8', '#a855f7'],
  },
  aurora: {
    name: 'Aurora',
    bgBase: 'linear-gradient(135deg, #1a1035 0%, #15203a 30%, #0f1a30 60%, #1a1540 100%)',
    blob1: 'radial-gradient(circle, rgba(56,189,248,.3) 0%, transparent 70%)',
    blob2: 'radial-gradient(circle, rgba(168,85,247,.28) 0%, transparent 70%)',
    blob3: 'radial-gradient(circle, rgba(244,114,182,.22) 0%, transparent 70%)',
    strip: 'linear-gradient(180deg, #08080f, #0e0e1a 55%, transparent)',
    panel: 'rgba(20,20,42,.82)', card: 'rgba(30,28,58,.65)', card2: 'rgba(30,28,58,.45)',
    dark: '#eee8f5', dark2: '#d8d0e8',
    accent: '#38bdf8', accent2: '#7dd3fc', accentBg: 'rgba(56,189,248,.1)',
    orange: '#f472b6', orange2: '#f9a8d4', orangeBg: 'rgba(244,114,182,.1)',
    t1: '#eae5f5', t2: '#908aa5', t3: '#5a5572', t4: '#3a3550',
    border: 'rgba(255,255,255,.08)', border2: 'rgba(255,255,255,.04)',
    sh: '0 2px 10px rgba(0,0,0,.2), 0 8px 32px rgba(0,0,0,.18)',
    sh2: '0 4px 16px rgba(0,0,0,.28), 0 16px 48px rgba(0,0,0,.22)',
    inputBg: 'rgba(255,255,255,.07)', hoverBg: 'rgba(255,255,255,.05)',
    tableHover: 'rgba(56,189,248,.05)', loadingBg: 'rgba(20,20,42,.7)',
    glassInset: 'inset 0 1px 0 rgba(255,255,255,.08)',
    preview: ['#1a1035', '#38bdf8', '#f472b6'],
  },
  ocean: {
    name: 'Ocean',
    bgBase: 'linear-gradient(135deg, #c0e8f0 0%, #a8dce8 25%, #b0e0f0 50%, #98d8e8 75%, #b8e4f2 100%)',
    blob1: 'radial-gradient(circle, rgba(56,189,248,.3) 0%, transparent 70%)',
    blob2: 'radial-gradient(circle, rgba(20,184,166,.25) 0%, transparent 70%)',
    blob3: 'radial-gradient(circle, rgba(255,255,255,.2) 0%, transparent 70%)',
    strip: 'linear-gradient(180deg, #0f3048, #154060 55%, transparent)',
    panel: 'rgba(230,248,255,.78)', card: 'rgba(255,255,255,.58)', card2: 'rgba(255,255,255,.4)',
    dark: '#0f3048', dark2: '#154060',
    accent: '#0891b2', accent2: '#22d3ee', accentBg: 'rgba(8,145,178,.07)',
    orange: '#f97316', orange2: '#fb923c', orangeBg: 'rgba(249,115,22,.07)',
    t1: '#0f3048', t2: '#4a7080', t3: '#80a0ad', t4: '#b0c8d0',
    border: 'rgba(255,255,255,.55)', border2: 'rgba(0,0,0,.04)',
    sh: '0 2px 8px rgba(15,48,72,.05), 0 8px 32px rgba(15,48,72,.04)',
    sh2: '0 4px 16px rgba(15,48,72,.08), 0 16px 48px rgba(15,48,72,.06)',
    inputBg: 'rgba(255,255,255,.5)', hoverBg: 'rgba(255,255,255,.25)',
    tableHover: 'rgba(8,145,178,.03)', loadingBg: 'rgba(230,248,255,.65)',
    glassInset: 'inset 0 1px 0 rgba(255,255,255,.55)',
    preview: ['#a8dce8', '#0891b2', '#f97316'],
  },
  neon: {
    name: 'Neon',
    bgBase: 'linear-gradient(135deg, #18082a 0%, #1a0c35 25%, #200e40 50%, #150828 75%, #1c0a30 100%)',
    blob1: 'radial-gradient(circle, rgba(236,72,153,.3) 0%, transparent 70%)',
    blob2: 'radial-gradient(circle, rgba(6,182,212,.28) 0%, transparent 70%)',
    blob3: 'radial-gradient(circle, rgba(168,85,247,.25) 0%, transparent 70%)',
    strip: 'linear-gradient(180deg, #0a0415, #10081e 55%, transparent)',
    panel: 'rgba(25,12,45,.85)', card: 'rgba(35,18,60,.65)', card2: 'rgba(35,18,60,.45)',
    dark: '#f5e0ff', dark2: '#e0c8f5',
    accent: '#06b6d4', accent2: '#22d3ee', accentBg: 'rgba(6,182,212,.1)',
    orange: '#ec4899', orange2: '#f472b6', orangeBg: 'rgba(236,72,153,.1)',
    t1: '#f0e5fa', t2: '#a088b8', t3: '#6a5580', t4: '#403050',
    border: 'rgba(255,255,255,.07)', border2: 'rgba(255,255,255,.03)',
    sh: '0 2px 10px rgba(0,0,0,.25), 0 8px 32px rgba(0,0,0,.2)',
    sh2: '0 4px 16px rgba(0,0,0,.3), 0 16px 48px rgba(0,0,0,.25)',
    inputBg: 'rgba(255,255,255,.06)', hoverBg: 'rgba(255,255,255,.04)',
    tableHover: 'rgba(6,182,212,.05)', loadingBg: 'rgba(25,12,45,.7)',
    glassInset: 'inset 0 1px 0 rgba(255,255,255,.07)',
    preview: ['#18082a', '#06b6d4', '#ec4899'],
  },
  // ── Yangi premium temalar ──
  moss: {
    name: 'Moss',
    bgBase: 'linear-gradient(135deg, #c8d8c4 0%, #b8ccb4 30%, #a8c0a4 60%, #bcd0b8 100%)',
    blob1: 'radial-gradient(circle, rgba(76,145,100,.2) 0%, transparent 70%)',
    blob2: 'radial-gradient(circle, rgba(160,190,140,.25) 0%, transparent 70%)',
    blob3: 'radial-gradient(circle, rgba(255,255,255,.15) 0%, transparent 70%)',
    strip: 'linear-gradient(180deg, #1e2e24, #2a3e30 55%, transparent)',
    panel: 'rgba(232,240,228,.75)', card: 'rgba(255,255,255,.55)', card2: 'rgba(255,255,255,.4)',
    dark: '#1e2e24', dark2: '#2a3e30',
    accent: '#4c9164', accent2: '#6aad80', accentBg: 'rgba(76,145,100,.07)',
    orange: '#c4854a', orange2: '#d49a60', orangeBg: 'rgba(196,133,74,.06)',
    t1: '#1e2e24', t2: '#5a6e5e', t3: '#8ea894', t4: '#b8ccbc',
    border: 'rgba(255,255,255,.5)', border2: 'rgba(0,0,0,.04)',
    sh: '0 2px 8px rgba(30,46,36,.04), 0 8px 32px rgba(30,46,36,.04)',
    sh2: '0 4px 16px rgba(30,46,36,.07), 0 16px 48px rgba(30,46,36,.05)',
    inputBg: 'rgba(255,255,255,.48)', hoverBg: 'rgba(255,255,255,.22)',
    tableHover: 'rgba(76,145,100,.03)', loadingBg: 'rgba(232,240,228,.6)',
    glassInset: 'inset 0 1px 0 rgba(255,255,255,.5)',
    preview: ['#b8ccb4', '#4c9164', '#c4854a'],
  },
  pearl: {
    name: 'Pearl',
    bgBase: 'linear-gradient(135deg, #e8e4e0 0%, #ddd8d4 30%, #e4e0dc 60%, #eae6e2 100%)',
    blob1: 'radial-gradient(circle, rgba(180,160,140,.2) 0%, transparent 70%)',
    blob2: 'radial-gradient(circle, rgba(160,170,185,.2) 0%, transparent 70%)',
    blob3: 'radial-gradient(circle, rgba(255,255,255,.2) 0%, transparent 70%)',
    strip: 'linear-gradient(180deg, #28282e, #38383e 55%, transparent)',
    panel: 'rgba(244,240,236,.78)', card: 'rgba(255,255,255,.6)', card2: 'rgba(255,255,255,.42)',
    dark: '#28282e', dark2: '#38383e',
    accent: '#7a6e62', accent2: '#9a8e82', accentBg: 'rgba(122,110,98,.06)',
    orange: '#b87c5a', orange2: '#cc9470', orangeBg: 'rgba(184,124,90,.06)',
    t1: '#28282e', t2: '#6a6a72', t3: '#9a9aa2', t4: '#c0c0c8',
    border: 'rgba(255,255,255,.55)', border2: 'rgba(0,0,0,.04)',
    sh: '0 2px 8px rgba(0,0,0,.03), 0 8px 32px rgba(0,0,0,.03)',
    sh2: '0 4px 16px rgba(0,0,0,.05), 0 16px 48px rgba(0,0,0,.04)',
    inputBg: 'rgba(255,255,255,.52)', hoverBg: 'rgba(255,255,255,.25)',
    tableHover: 'rgba(122,110,98,.03)', loadingBg: 'rgba(244,240,236,.65)',
    glassInset: 'inset 0 1px 0 rgba(255,255,255,.55)',
    preview: ['#ddd8d4', '#7a6e62', '#b87c5a'],
  },
  midnight: {
    name: 'Midnight',
    bgBase: 'linear-gradient(135deg, #141824 0%, #1a2030 30%, #161c28 60%, #181e2c 100%)',
    blob1: 'radial-gradient(circle, rgba(100,140,200,.2) 0%, transparent 70%)',
    blob2: 'radial-gradient(circle, rgba(140,120,180,.18) 0%, transparent 70%)',
    blob3: 'radial-gradient(circle, rgba(80,160,180,.15) 0%, transparent 70%)',
    strip: 'linear-gradient(180deg, #0a0e16, #0e1220 55%, transparent)',
    panel: 'rgba(22,28,40,.8)', card: 'rgba(30,36,52,.6)', card2: 'rgba(30,36,52,.4)',
    dark: '#e4e0ec', dark2: '#d0cce0',
    accent: '#6a9fd8', accent2: '#88b4e4', accentBg: 'rgba(106,159,216,.08)',
    orange: '#e0956a', orange2: '#e8aa84', orangeBg: 'rgba(224,149,106,.08)',
    t1: '#dcdae8', t2: '#8888a0', t3: '#585870', t4: '#383848',
    border: 'rgba(255,255,255,.06)', border2: 'rgba(255,255,255,.03)',
    sh: '0 2px 10px rgba(0,0,0,.18), 0 8px 32px rgba(0,0,0,.15)',
    sh2: '0 4px 16px rgba(0,0,0,.22), 0 16px 48px rgba(0,0,0,.18)',
    inputBg: 'rgba(255,255,255,.06)', hoverBg: 'rgba(255,255,255,.04)',
    tableHover: 'rgba(106,159,216,.04)', loadingBg: 'rgba(22,28,40,.7)',
    glassInset: 'inset 0 1px 0 rgba(255,255,255,.06)',
    preview: ['#141824', '#6a9fd8', '#e0956a'],
  },
  rose: {
    name: 'Rose',
    bgBase: 'linear-gradient(135deg, #e8d4d0 0%, #e0ccc8 30%, #dcc4c0 60%, #e4d0cc 100%)',
    blob1: 'radial-gradient(circle, rgba(200,120,120,.18) 0%, transparent 70%)',
    blob2: 'radial-gradient(circle, rgba(180,140,160,.2) 0%, transparent 70%)',
    blob3: 'radial-gradient(circle, rgba(255,255,255,.15) 0%, transparent 70%)',
    strip: 'linear-gradient(180deg, #2c2024, #3e2c32 55%, transparent)',
    panel: 'rgba(244,236,234,.76)', card: 'rgba(255,255,255,.56)', card2: 'rgba(255,255,255,.4)',
    dark: '#2c2024', dark2: '#3e2c32',
    accent: '#b06070', accent2: '#c87888', accentBg: 'rgba(176,96,112,.06)',
    orange: '#c89060', orange2: '#d8a478', orangeBg: 'rgba(200,144,96,.06)',
    t1: '#2c2024', t2: '#6e5860', t3: '#a08890', t4: '#c4b0b8',
    border: 'rgba(255,255,255,.52)', border2: 'rgba(0,0,0,.04)',
    sh: '0 2px 8px rgba(44,32,36,.04), 0 8px 32px rgba(44,32,36,.04)',
    sh2: '0 4px 16px rgba(44,32,36,.07), 0 16px 48px rgba(44,32,36,.05)',
    inputBg: 'rgba(255,255,255,.48)', hoverBg: 'rgba(255,255,255,.22)',
    tableHover: 'rgba(176,96,112,.03)', loadingBg: 'rgba(244,236,234,.65)',
    glassInset: 'inset 0 1px 0 rgba(255,255,255,.52)',
    preview: ['#e0ccc8', '#b06070', '#c89060'],
  },
  fog: {
    name: 'Fog',
    bgBase: 'linear-gradient(135deg, #d4d8e0 0%, #c8ccd6 30%, #d0d4dc 60%, #d8dce4 100%)',
    blob1: 'radial-gradient(circle, rgba(120,140,180,.2) 0%, transparent 70%)',
    blob2: 'radial-gradient(circle, rgba(140,160,180,.18) 0%, transparent 70%)',
    blob3: 'radial-gradient(circle, rgba(255,255,255,.18) 0%, transparent 70%)',
    strip: 'linear-gradient(180deg, #22262e, #303640 55%, transparent)',
    panel: 'rgba(236,238,244,.76)', card: 'rgba(255,255,255,.56)', card2: 'rgba(255,255,255,.4)',
    dark: '#22262e', dark2: '#303640',
    accent: '#5a7a9a', accent2: '#7494b0', accentBg: 'rgba(90,122,154,.06)',
    orange: '#c08850', orange2: '#d4a068', orangeBg: 'rgba(192,136,80,.06)',
    t1: '#22262e', t2: '#5a6070', t3: '#8a909a', t4: '#b4bac4',
    border: 'rgba(255,255,255,.52)', border2: 'rgba(0,0,0,.04)',
    sh: '0 2px 8px rgba(34,38,46,.04), 0 8px 32px rgba(34,38,46,.04)',
    sh2: '0 4px 16px rgba(34,38,46,.07), 0 16px 48px rgba(34,38,46,.05)',
    inputBg: 'rgba(255,255,255,.5)', hoverBg: 'rgba(255,255,255,.22)',
    tableHover: 'rgba(90,122,154,.03)', loadingBg: 'rgba(236,238,244,.65)',
    glassInset: 'inset 0 1px 0 rgba(255,255,255,.52)',
    preview: ['#c8ccd6', '#5a7a9a', '#c08850'],
  },
  ember: {
    name: 'Ember',
    bgBase: 'linear-gradient(135deg, #1c1412 0%, #241a16 30%, #201614 60%, #1e1614 100%)',
    blob1: 'radial-gradient(circle, rgba(200,100,50,.2) 0%, transparent 70%)',
    blob2: 'radial-gradient(circle, rgba(160,80,40,.18) 0%, transparent 70%)',
    blob3: 'radial-gradient(circle, rgba(220,140,60,.12) 0%, transparent 70%)',
    strip: 'linear-gradient(180deg, #0e0a08, #141010 55%, transparent)',
    panel: 'rgba(36,28,24,.82)', card: 'rgba(48,38,32,.6)', card2: 'rgba(48,38,32,.4)',
    dark: '#f0e4dc', dark2: '#e0d4cc',
    accent: '#d4854a', accent2: '#e09a60', accentBg: 'rgba(212,133,74,.08)',
    orange: '#c86040', orange2: '#e07858', orangeBg: 'rgba(200,96,64,.08)',
    t1: '#ecdcd0', t2: '#a08878', t3: '#685848', t4: '#403028',
    border: 'rgba(255,255,255,.06)', border2: 'rgba(255,255,255,.03)',
    sh: '0 2px 10px rgba(0,0,0,.2), 0 8px 32px rgba(0,0,0,.18)',
    sh2: '0 4px 16px rgba(0,0,0,.25), 0 16px 48px rgba(0,0,0,.2)',
    inputBg: 'rgba(255,255,255,.06)', hoverBg: 'rgba(255,255,255,.04)',
    tableHover: 'rgba(212,133,74,.04)', loadingBg: 'rgba(36,28,24,.7)',
    glassInset: 'inset 0 1px 0 rgba(255,255,255,.06)',
    preview: ['#1c1412', '#d4854a', '#c86040'],
  },
}

const currentTheme = ref(localStorage.getItem('theme') || 'sand')
const theme = computed(() => themes[currentTheme.value] || themes.sand)

const applyTheme = (t) => {
  const r = document.documentElement.style
  r.setProperty('--panel', t.panel); r.setProperty('--card', t.card); r.setProperty('--card2', t.card2)
  r.setProperty('--dark', t.dark); r.setProperty('--dark2', t.dark2)
  r.setProperty('--accent', t.accent); r.setProperty('--accent2', t.accent2); r.setProperty('--accent-bg', t.accentBg)
  r.setProperty('--orange', t.orange); r.setProperty('--orange2', t.orange2); r.setProperty('--orange-bg', t.orangeBg)
  r.setProperty('--t1', t.t1); r.setProperty('--t2', t.t2); r.setProperty('--t3', t.t3); r.setProperty('--t4', t.t4)
  r.setProperty('--border', t.border); r.setProperty('--border2', t.border2)
  r.setProperty('--sh', t.sh); r.setProperty('--sh2', t.sh2)
  r.setProperty('--input-bg', t.inputBg); r.setProperty('--hover-bg', t.hoverBg)
  r.setProperty('--table-hover', t.tableHover); r.setProperty('--loading-bg', t.loadingBg)
  r.setProperty('--glass-inset', t.glassInset)
}

watch(currentTheme, (key) => { const t = themes[key]; if (t) applyTheme(t) })
onMounted(() => { applyTheme(theme.value) })

// expose for MainLayout theme switcher
window.__themes = themes
window.__currentTheme = currentTheme

return (_ctx, _cache) => {
  const _component_router_view = _resolveComponent("router-view")
  const _component_el_config_provider = _resolveComponent("el-config-provider")

  return (_openBlock(), _createBlock(_component_el_config_provider, { locale: elementLocale.value }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "bg",
        style: _normalizeStyle({ background: theme.value.bgBase })
      }, [
        _createElementVNode("div", {
          class: "blob blob-1",
          style: _normalizeStyle({ background: theme.value.blob1 })
        }, null, 4),
        _createElementVNode("div", {
          class: "blob blob-2",
          style: _normalizeStyle({ background: theme.value.blob2 })
        }, null, 4),
        _createElementVNode("div", {
          class: "blob blob-3",
          style: _normalizeStyle({ background: theme.value.blob3 })
        }, null, 4),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "bg-noise" }, null, -1))
      ], 4),
      _createElementVNode("div", {
        class: "dark-strip",
        style: _normalizeStyle({ background: theme.value.strip })
      }, null, 4),
      _createVNode(_component_router_view),
      _createVNode(InstallPrompt)
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

}